<div class="main">
    <toolbar></toolbar>
    <navbar></navbar>
    <mat-divider></mat-divider>
    <div class="container">
        <router-outlet></router-outlet>
    </div>
    <mat-divider></mat-divider>
    <footer></footer>
</div>
